import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Modal, Field, SaButton, sa, errMsg } from './ui';

export const CompanyFormModal = ({ company, onClose, onSaved }) => {
  const isEdit = Boolean(company);
  const [form, setForm] = useState({
    name: company?.name || '', slug: company?.slug || '',
    contact_email: company?.settings?.contact_email || '',
    admin_email: '', admin_name: '', admin_password: '',
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return toast.error('Company name is required');
    setSaving(true);
    try {
      if (isEdit) {
        await axios.patch(`/superadmin/companies/${company.id}`, {
          name: form.name, slug: form.slug || undefined, settings: { contact_email: form.contact_email },
        });
        toast.success('Company updated');
      } else {
        const payload = { name: form.name, slug: form.slug || undefined, settings: { contact_email: form.contact_email } };
        if (form.admin_email) Object.assign(payload, { admin_email: form.admin_email, admin_name: form.admin_name, admin_password: form.admin_password });
        await axios.post('/superadmin/companies', payload);
        toast.success(`Company "${form.name}" created`);
      }
      onSaved();
    } catch (err) {
      toast.error(errMsg(err, 'Save failed'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title={isEdit ? 'Edit Company' : 'New Company'} onClose={onClose} testId="company-form-modal">
      <form onSubmit={submit}>
        <Field label="Company name"><input data-testid="company-name-input" style={sa.input} value={form.name} onChange={set('name')} placeholder="Acme Apparel" autoFocus /></Field>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <Field label="Slug (URL-safe id)"><input data-testid="company-slug-input" style={sa.input} value={form.slug} onChange={set('slug')} placeholder="auto from name" /></Field>
          <Field label="Contact email"><input data-testid="company-contact-input" style={sa.input} value={form.contact_email} onChange={set('contact_email')} placeholder="owner@acme.com" /></Field>
        </div>
        {!isEdit && (
          <div style={{ borderTop: '1px solid #27272A', marginTop: 8, paddingTop: 16 }}>
            <p style={{ ...sa.overline, marginBottom: 12 }}>First company admin (optional)</p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <Field label="Admin email"><input data-testid="company-admin-email-input" style={sa.input} value={form.admin_email} onChange={set('admin_email')} placeholder="admin@acme.com" /></Field>
              <Field label="Admin name"><input data-testid="company-admin-name-input" style={sa.input} value={form.admin_name} onChange={set('admin_name')} placeholder="Jane Doe" /></Field>
            </div>
            <Field label="Temporary password (min 8 chars)"><input data-testid="company-admin-password-input" type="text" style={sa.input} value={form.admin_password} onChange={set('admin_password')} placeholder="Share securely with the admin" /></Field>
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
          <SaButton variant="ghost" onClick={onClose}>Cancel</SaButton>
          <SaButton data-testid="company-form-submit" type="submit" disabled={saving}>{saving ? 'Saving…' : isEdit ? 'Save changes' : 'Create company'}</SaButton>
        </div>
      </form>
    </Modal>
  );
};
